import type { BuildOrganizationVisibleMicroAppsQueryKeyParams } from '../types';

const buildOrganizationVisibleMicroAppsQueryKey = ({
    organizationId,
}: BuildOrganizationVisibleMicroAppsQueryKeyParams): string[] => [
    'organization-visible-micro-apps',
    organizationId,
];

export default buildOrganizationVisibleMicroAppsQueryKey;
